The response from the `deleteUnpostedPositionProfile` mutation.
